module.exports = __webpack_public_path__ + "img/ask-popup-bg.120dc0e4.png";